// extracted by mini-css-extract-plugin
export var base = "_16-0";
export var updateBanner = "_16-1";